// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OcK4jT {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  height: 167px;
  justify-content: space-between;
  padding: 0 var(--spacing-3);
  position: relative;
  width: 100%;
}

.Y4tj1v {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1 1 0;
  min-width: 0;
  z-index: 2;
}

.TDxci9 {
  width: var(--spacing-3);
  height: var(--spacing-3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--spacing-1-5);
  position: relative;
  border: 1px solid transparent;
  color: var(--text-neutral-silver);
}

.EaTEJZ .TDxci9 {
  background-color: var(--status-success);
  color: var(--text-neutral-white);
  border-color: var(--status-success);
}

.qC506q .TDxci9 {
  background-color: var(--icon-primary-medium);
  color: var(--text-neutral-white);
  border-color: var(--icon-primary-medium);
}

.t2hxWm .TDxci9 {
  background-color: var(--status-error);
  color: var(--text-neutral-white);
  border-color: var(--status-error);
}

.X1AbG7 .TDxci9 {
  background-color: var(--background-white);
  color: var(--text-neutral-silver);
  border-color: var(--stroke-neutral-silver);
}

.zfDg_Q {
  width: 12px !important;
  height: 12px !important;
  cursor: default !important;
}

.bD8GXW {
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
}

.raXIYZ {
  margin-bottom: var(--spacing-1-5);
  width: var(--spacing-4);
  height: var(--spacing-4);
  display: flex;
  align-items: center;
  justify-content: center;
}

.Qe9RdL {
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-100);
  text-align: center;
}

.EaTEJZ .raXIYZ {
  color: #212121;
}

.EaTEJZ .Qe9RdL {
  color: var(--icon-neutral-dark);
}

.qC506q .raXIYZ {
  color: #212121;
}

.qC506q .Qe9RdL {
  color: var(--icon-neutral-dark);
}

.t2hxWm .Qe9RdL {
  color: var(--icon-neutral-dark);
}

.X1AbG7 .raXIYZ {
  color: #bdbdbd;
}

.X1AbG7 .Qe9RdL {
  color: var(--text-neutral-silver);
}

.ZNQIMe {
  position: absolute;
  top: 55px !important;
  left: calc(50% + 12px);
  width: calc(100% - 24px);
  height: 1px;
  z-index: 1;
}

.EaTEJZ .ZNQIMe {
  background: var(--status-success);
}

.mRwmA7 .ZNQIMe {
  background: linear-gradient(
    to right,
    var(--status-success) 0%,
    var(--icon-primary-medium) 50%,
    var(--icon-primary-medium) 50%,
    var(--icon-primary-medium) 100%
  );
}

.uHt6XE .ZNQIMe {
  background: linear-gradient(
    to right,
    var(--status-success) 0%,
    var(--status-success) 50%,
    var(--status-error) 50%,
    var(--status-error) 100%
  );
}

.qC506q .ZNQIMe,
.X1AbG7 .ZNQIMe {
  background: var(--stroke-neutral-silver);
}

.nf1V__ .ZNQIMe {
  background: linear-gradient(
    to right,
    var(--status-success) 0%,
    var(--icon-primary-medium) 50%,
    var(--stroke-neutral-silver) 50%,
    var(--stroke-neutral-silver) 100%
  );
}

@media (max-width: 768px) {
  .OcK4jT {
    padding: 0 var(--spacing-2);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/EmissorCardTrackingPage/components/StatusWizard/StatusWizard.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;;;;;;GAMC;AACH;;AAEA;EACE;;;;;;GAMC;AACH;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE;;;;;;GAMC;AACH;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".statusWizardSection {\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  height: 167px;\n  justify-content: space-between;\n  padding: 0 var(--spacing-3);\n  position: relative;\n  width: 100%;\n}\n\n.wizardStep {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  flex: 1 1 0;\n  min-width: 0;\n  z-index: 2;\n}\n\n.stepIndicator {\n  width: var(--spacing-3);\n  height: var(--spacing-3);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: var(--spacing-1-5);\n  position: relative;\n  border: 1px solid transparent;\n  color: var(--text-neutral-silver);\n}\n\n.stepCompleted .stepIndicator {\n  background-color: var(--status-success);\n  color: var(--text-neutral-white);\n  border-color: var(--status-success);\n}\n\n.stepCurrent .stepIndicator {\n  background-color: var(--icon-primary-medium);\n  color: var(--text-neutral-white);\n  border-color: var(--icon-primary-medium);\n}\n\n.stepCancelled .stepIndicator {\n  background-color: var(--status-error);\n  color: var(--text-neutral-white);\n  border-color: var(--status-error);\n}\n\n.stepPending .stepIndicator {\n  background-color: var(--background-white);\n  color: var(--text-neutral-silver);\n  border-color: var(--stroke-neutral-silver);\n}\n\n.cancelledIcon {\n  width: 12px !important;\n  height: 12px !important;\n  cursor: default !important;\n}\n\n.stepNumber {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n}\n\n.stepIcon {\n  margin-bottom: var(--spacing-1-5);\n  width: var(--spacing-4);\n  height: var(--spacing-4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.stepLabel {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-100);\n  text-align: center;\n}\n\n.stepCompleted .stepIcon {\n  color: #212121;\n}\n\n.stepCompleted .stepLabel {\n  color: var(--icon-neutral-dark);\n}\n\n.stepCurrent .stepIcon {\n  color: #212121;\n}\n\n.stepCurrent .stepLabel {\n  color: var(--icon-neutral-dark);\n}\n\n.stepCancelled .stepLabel {\n  color: var(--icon-neutral-dark);\n}\n\n.stepPending .stepIcon {\n  color: #bdbdbd;\n}\n\n.stepPending .stepLabel {\n  color: var(--text-neutral-silver);\n}\n\n.stepConnector {\n  position: absolute;\n  top: 55px !important;\n  left: calc(50% + 12px);\n  width: calc(100% - 24px);\n  height: 1px;\n  z-index: 1;\n}\n\n.stepCompleted .stepConnector {\n  background: var(--status-success);\n}\n\n.lastCompleted .stepConnector {\n  background: linear-gradient(\n    to right,\n    var(--status-success) 0%,\n    var(--icon-primary-medium) 50%,\n    var(--icon-primary-medium) 50%,\n    var(--icon-primary-medium) 100%\n  );\n}\n\n.lastBeforeCancelled .stepConnector {\n  background: linear-gradient(\n    to right,\n    var(--status-success) 0%,\n    var(--status-success) 50%,\n    var(--status-error) 50%,\n    var(--status-error) 100%\n  );\n}\n\n.stepCurrent .stepConnector,\n.stepPending .stepConnector {\n  background: var(--stroke-neutral-silver);\n}\n\n.isCurrentFirstStep .stepConnector {\n  background: linear-gradient(\n    to right,\n    var(--status-success) 0%,\n    var(--icon-primary-medium) 50%,\n    var(--stroke-neutral-silver) 50%,\n    var(--stroke-neutral-silver) 100%\n  );\n}\n\n@media (max-width: 768px) {\n  .statusWizardSection {\n    padding: 0 var(--spacing-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusWizardSection": `OcK4jT`,
	"wizardStep": `Y4tj1v`,
	"stepIndicator": `TDxci9`,
	"stepCompleted": `EaTEJZ`,
	"stepCurrent": `qC506q`,
	"stepCancelled": `t2hxWm`,
	"stepPending": `X1AbG7`,
	"cancelledIcon": `zfDg_Q`,
	"stepNumber": `bD8GXW`,
	"stepIcon": `raXIYZ`,
	"stepLabel": `Qe9RdL`,
	"stepConnector": `ZNQIMe`,
	"lastCompleted": `mRwmA7`,
	"lastBeforeCancelled": `uHt6XE`,
	"isCurrentFirstStep": `nf1V__`
};
module.exports = ___CSS_LOADER_EXPORT___;
